import { Map } from 'immutable'
import * as API from '../../utils/API'
import { loading, loadingFailure, loadingSuccess } from './status'
import Actions from './utils/actions'
import mergePayload from './utils/mergePayload'

const RESOURCE_NAME = 'vantagem'

const endpoint = (action, id) => {
  switch (action) {
    case Actions.INDEX:
    case Actions.CREATE:
      return `/acl/pontos/${id}/vantagens`

    case Actions.SHOW:
    case Actions.UPDATE:
    case Actions.DESTROY:
      return `/acl/vantagens/${id}`

    default:
      return ''
  }
}

const resolve = (dispatch, resource) => {
  dispatch(loadingSuccess(RESOURCE_NAME))
  dispatch(loadingVantagemSuccess(resource))
  return Promise.resolve(resource)
}

const resolveDestroy = (dispatch, id) => {
  dispatch(loadingSuccess(RESOURCE_NAME))
  dispatch(destroyingVantagemSuccess(id))
  return Promise.resolve()
}

const reject = (dispatch, error) => {
  dispatch(loadingFailure(RESOURCE_NAME, error))
  return Promise.reject(error)
}

export const LOADING_VANTAGEM_SUCCESS = 'LOADING_VANTAGEM_SUCCESS'
export function loadingVantagemSuccess(vantagem) {
  return {
    type: LOADING_VANTAGEM_SUCCESS,
    vantagem,
  }
}

export const DESTROYING_VANTAGEM_SUCCESS = 'DESTROYING_VANTAGEM_SUCCESS'
export function destroyingVantagemSuccess(vantagemId) {
  return {
    type: DESTROYING_VANTAGEM_SUCCESS,
    vantagemId,
  }
}

export function fetchMultipleVantagem(parentId) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(endpoint(Actions.INDEX, parentId)).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function fetchVantagem(id) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(endpoint(Actions.SHOW, id)).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function createVantagem(parentId, vantagem) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(endpoint(Actions.CREATE, parentId), 'POST', vantagem).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function updateVantagem(id, vantagem) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(endpoint(Actions.UPDATE, id), 'PUT', vantagem).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function destroyVantagem(id) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return await API.call(endpoint(Actions.DESTROY, id), 'DELETE').then(
      () => resolveDestroy(dispatch, id),
      error => reject(dispatch, error)
    )
  }
}

export function importVantagem(multipleVantagem) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(endpoint('import'), 'POST', multipleVantagem).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

const vantagem = (state = new Map({}), action) => {
  switch (action.type) {
    case LOADING_VANTAGEM_SUCCESS: {
      const { vantagem: payload } = action
      return mergePayload(state, payload)
    }

    case DESTROYING_VANTAGEM_SUCCESS:
      return state.delete(action.vantagemId.toString())

    default:
      return state
  }
}

export default vantagem
